// Cast is accepted pattern for framework Property vs customer-data-objects Property
// See https://git.hubteam.com/HubSpot/customer-data-properties/blob/bf83e78aad919ded911ab1eb882617eb4eb8062e/customer-data-properties/static/js/form/api.ts#L13
export const castPropertyToAny = property => property;
export const getObjectLabelPropertyName = objectTypeDefinition => {
  var _objectTypeDefinition;
  return (_objectTypeDefinition = objectTypeDefinition.primaryDisplayLabelPropertyName) !== null && _objectTypeDefinition !== void 0 ? _objectTypeDefinition : objectTypeDefinition.secondaryDisplayLabelPropertyNames[0];
};
export const getPropertyValue = (subject, property) => {
  var _subject$properties$p;
  return (_subject$properties$p = subject.properties[property]) === null || _subject$properties$p === void 0 ? void 0 : _subject$properties$p.value;
};